import { render } from "./Artboard_SpotifyPlaylist.vue?vue&type=template&id=4195c884&scoped=true"
import script from "./Artboard_SpotifyPlaylist.vue?vue&type=script&lang=js"
export * from "./Artboard_SpotifyPlaylist.vue?vue&type=script&lang=js"

import "./Artboard_SpotifyPlaylist.vue?vue&type=style&index=0&id=4195c884&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4195c884"

export default script